
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Getting-Started/Usage.html",
      function () {
        return require("private-next-pages/Getting-Started/Usage.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Getting-Started/Usage.html"])
      });
    }
  